import resume from '../Resume.pdf'

export const icons = [
    {
        name:"Resume",
        image:"/Images/document.png",
        link: resume
    
    },
    {
        name:"LinkedIn",
        image:"/Images/linkedin.png",
        link:"https://www.linkedin.com/in/griffin-matthews/"
    
    },
    {
        name:"GitHub",
        image:"/Images/github-logo.png",
        link:"https://github.com/Griffmatt"
    
    },
]